import { analytics } from '../../utils'
import { FirebaseContext } from './FirebaseContext'

export const FirebaseProvider = (props: { children: React.ReactNode }) => {
  return (
    <FirebaseContext.Provider value={analytics}>
      {props.children}
    </FirebaseContext.Provider>
  )
}
